
<div class="w-full mb-6">
    <div class="grid">
        <div class="col-12 md:col-4">
            <split-search></split-search>
        </div>
        <div class="col-12 md:col-8 flex align-items-center justify-content-end">
          <p-calendar class="mr-2" [showClear]="true" [(ngModel)]="selectedDate" placeholder="Data" />
          <p-dropdown 
          styleClass="filterDropdownLargeWidth"
          [(ngModel)]="selectedProfessional"
          [options]="professionalOptions"
          optionLabel="name"
          optionValue="id"
          placeholder="Profissional"
          (onChange)="addProfessionalFilter()"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [ngModelOptions]="{ standalone: true }"
        />
            <!-- <button
                pButton
                class="split-button-orange-1"
                type="button"
                label="Categoria"
            ></button>   -->
        </div>     
    </div>
    <div class="scroll_container table">
      <div class="gradient"></div>
      <split-table
        class="table-with-buttons"
        card-body
        [checklist]="false"
        [widthColumns]="[10, 15, 30, 15, 15, 15]"
        [dados]="data!"
        theme="tertiary"
      >
        <ng-template #header>
          <div class="text-center w-full">Categoria</div>
        </ng-template>
        <ng-template #coluna let-item="dadosLinha">
          <div class="primary text-center	w-full">
            {{ item.categoria }}
          </div>
        </ng-template>
  
        <ng-template #header> Data </ng-template>
        <ng-template #coluna let-item="dadosLinha">
          <div class="add_ellipsis">
            {{ item.data }}
          </div>
        </ng-template>
  
        <ng-template #header> Valor </ng-template>
        <ng-template #coluna let-item="dadosLinha">
          <div class="add_ellipsis">
            {{ item.valor }}
          </div>
        </ng-template>
  
        <ng-template #header> Profissional </ng-template>
        <ng-template #coluna let-item="dadosLinha">
            {{ item.profissional }}
        </ng-template>
  
        <ng-template #header> Conta </ng-template>
        <ng-template #coluna let-item="dadosLinha">
            {{ item.conta }}
        </ng-template>
  
        <ng-template #header> Forma pgto </ng-template>
        <ng-template #coluna let-item="dadosLinha">
            {{ item.formaPgto  }}
        </ng-template>

        <ng-template #header> Observações </ng-template>
        <ng-template #coluna let-item="dadosLinha">
            {{ item.formaPgto  }}
        </ng-template>

        <ng-template #header></ng-template>
        <ng-template #coluna let-item="dadosLinha">
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true"></p-button>
        </ng-template>
      </split-table>
    </div>
  </div>
  